export default __webpack_public_path__ + "static/media/Microsoft-Logo-Partner.599c276f.svg";